import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-label-content',
    templateUrl: './label-content.component.html',
    standalone: false
})
export class LabelContentComponent {
  @Input() isRequired: boolean;
}
